<h2>
    Customer Name
    <button class="icon--add btn--default" *ngIf="canEdit" (click)="addName()">Add Name</button>
    <button class="icon--edit btn--default" ifACSTransaction="LECURestrictions" (click)="launchUpdateDetailsModal()">LECU</button>
    <button class="icon--renew btn--default" *ngIf="isRestricted == true" (click)="refreshData()">Refresh</button>
</h2>
<p-table #dt
         [value]="names"
         styleClass="p-datatable-striped">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Name Type</th>
            <th>Name</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="2 + (!!canEdit ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData">
            <td>{{ rowData.customerNameType }}</td>
            <td class="td--hover-show">{{ rowData.customerName }}</td>
            <td class="text-center" *ngIf="canEdit">
                <a class="icon--edit" title="Edit Name" href="javascript:void(0);" (click)="editName(rowData.customerNameId)"></a>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" let-columns>
        <tr *ngIf="viewAdditionalNames">
            <td [attr.colspan]="2 + (!!canEdit ? 1 : 0)">
                <b><a href="javascript:void(0)" (click)="toggleViewNames()">{{ viewNamesTitle }}<i class="material-icons" *ngIf="!showViewNames">arrow_drop_down</i><i class="material-icons" *ngIf="showViewNames">arrow_drop_up</i></a></b>
            </td>
        </tr>
    </ng-template>
</p-table>